function openAi() {
    localStorage.setItem("ai", "true");
}
window.openAi = openAi;

function closeAi() {
    localStorage.setItem("ai", "false");
}
window.closeAi = closeAi;

$(document).ready(function () {
    // Important Stuffs
    if ($(".important-stuff").length) {
        get_important_stuff();
    }

    // var currentPage = 1;
    var currentPage = 0;
    $(".matehub .load-more-post").on("click", function (e) {
        e.preventDefault();

        var $this = $(this);
        const catID = $(this).data('cat-id');

        if (!$this.hasClass("disabled")) {
            $this.addClass("disabled");

            //reset page if cat is selected;
            // if( catID ) {
            //     currentPage = 1;
            // }

            currentPage = currentPage + 1;
            $.ajax({
                type: "GET",
                url: ajax_url,
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: {
                    action: "load_more_posts",
                    page: currentPage,
                    catID: catID ?? null,
                },
                success: function (resp) {
                    $(".matehub .posts").append(resp.data);
                    $this.removeClass("disabled");
                    if ( resp.totalPages - 2 == currentPage ) {
                        $this.remove();
                        setTimeout(function () {
                            $(".matehub .posts").find(".post.end").slideUp(600);
                        }, 3000);
                    }
                },
            });
        }
    });

    $('body').on('click', '.postCatFilter', function() {
        currentPage = 0;
        const catID = $(this).data('cat-id');
        $('.postCatFilter').removeClass('active');
        $('body .load-more-post').attr('data-cat-id', catID);
        $('body .load-more-post').data('cat-id', catID);
        $(this).addClass('active');
        $.ajax({
            type: "GET",
            url: ajax_url,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: {
                action: "load_posts_cat",
                catID: catID,
            },
            success: function (resp) {
                $(".matehub .posts").html(resp.data);
            },
        });
    });

    var currentPageUncharted = 1;
    $(".uncharted .load-more-post").on("click", function (e) {
        e.preventDefault();

        var $this = $(this);

        if (!$this.hasClass("disabled")) {
            $this.addClass("disabled");
            currentPageUncharted = currentPageUncharted + 1;
            $.ajax({
                type: "GET",
                url: ajax_url,
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: {
                    action: "load_more_posts_uncharted",
                    page: currentPageUncharted,
                },
                success: function (resp) {
                    $(".uncharted .posts").append(resp.data);
                    $this.removeClass("disabled");
                    if (resp.empty) {
                        $this.remove();
                        setTimeout(function () {
                            $(".uncharted .posts").find(".post.end").slideUp(600);
                        }, 3000);
                    }
                },
            });
        }
    });

    // Pagination
    $("body").on("click", ".prev", function () {
        var $this = $(this);
        const action = $this.data("action");
        const max = $this.data("max");
        const content = $this.data("content");

        let page = $this.data("page");

        var current_page = page;
        if (current_page > 1) {
            page--;
        }
        fetchPagination(".default-page .content .lists", action, page, content);
    });

    $("body").on("click", ".next", function (e) {
        e.stopPropagation();

        var $this = $(this);
        var $this = $(this);
        const action = $this.data("action");
        const max = $this.data("max");
        const content = $this.data("content");

        let page = $this.data("page");

        var current_page = page;
        if (current_page < max) {
            page++;
        }

        if (window.matchMedia("(max-width: 767px)").matches) {
            if (action === "search_faq_posts") {
                fetchPagination(".mobile-search-wrapper", action, page, content);
            } else {
                fetchPagination(".list.mobile-list .get-faq-post.active .lists", action, page, content);
            }
        } else {
            fetchPagination(".default-page .content .lists.desktop-lists", action, page, content);
            // fetchPagination('.mobile-search-wrapper',action,page,content);
        }
    });
});

// HELPER
function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
window.getParameterByName = getParameterByName;

function get_important_stuff() {
    $.ajax({
        type: "GET",
        url: ajax_url,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: {
            action: "get_important_stuff",
        },
        success: function (resp) {
            var is = "";
            $(".default-page .content .lists .content").html(resp.data);
        },
    });
}
window.get_important_stuff = get_important_stuff;

function fetchPagination(container, action, page, data) {
    var paginate = { page: page, content: data };
    $.ajax({
        type: "GET",
        url: ajax_url,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: {
            action: action,
            paginate: paginate,
        },
        success: function (resp) {
            $(container).find(".content").html(resp.data);
            var pagination_container = $(container).find(".paginate");
            make_paginate(pagination_container, resp.action, paginate.content, resp.page, resp.totalPages);
            // $('.result-count').html("Page "+resp.page+" of "+resp.totalPages);

            /*FIND '.result-count' FROM container, then add pagination */
            $(pagination_container)
                .find(".result-count")
                .html("Page " + resp.page + " of " + resp.totalPages);
        },
    });
}
window.fetchPagination = fetchPagination;

function make_paginate(container, action, data, page, totalPages) {
    if (totalPages > 1) {
        var prev_disabled = "";
        if (page == 1) {
            prev_disabled = "disabled='disabled'";
        }
        var next_disabled = "";
        if (page == totalPages) {
            next_disabled = "disabled='disabled'";
        }

        var html = "<h6 class='result-count'></h6>";
        html += "<div class='links'>";
        html +=
            "<button class='prev' data-action='" +
            action +
            "' data-page='" +
            page +
            "' data-max='" +
            totalPages +
            "' data-bs-content='" +
            data +
            "' " +
            prev_disabled +
            ">Previous</button>";
        html +=
            "<button class='next' data-action='" +
            action +
            "' data-page='" +
            page +
            "' data-max='" +
            totalPages +
            "' data-bs-content='" +
            data +
            "' " +
            next_disabled +
            ">Next</button>";
        html += "</div>";

        $(container).html(html);
    } else {
        $(container).html("");
    }
}
window.make_paginate = make_paginate;

function delay(callback, ms) {
    let timer;

    return function () {
        const context = this;
        const args = arguments;

        clearTimeout(timer);

        timer = setTimeout(function () {
            callback.apply(context, args);
            callback();
        }, ms || 0);
    };
}
window.delay = delay;

/**
 * Push history state to the search bar
 * @param {string} title
 * @param {string[]} params
 */
function pushWindowState(title, newParams) {
    var push = "";

    let params = getSearchParameters();

    for (const [key, value] of Object.entries(newParams)) {
        params[key] = value;
    }

    for (const [key, value] of Object.entries(params)) {
        push += (push == "" ? "?" : "&") + encodeURIComponent(key) + "=" + encodeURIComponent(value);
    }

    window.history.pushState(null, title, push);
}
window.pushWindowState = pushWindowState;

var is_mobile = false;
if (window.matchMedia("(max-width: 767px)").matches) {
    is_mobile = true;
}
window.is_mobile = is_mobile;

function getSearchParameters() {
    var prmstr = window.location.search.substr(1);
    return prmstr != null && prmstr != "" ? transformToAssocArray(prmstr) : {};
}

function transformToAssocArray(prmstr) {
    var params = {};
    var prmarr = prmstr.split("&");
    for (var i = 0; i < prmarr.length; i++) {
        var tmparr = prmarr[i].split("=");
        params[tmparr[0]] = tmparr[1] ?? null;
    }
    return params;
}
